module.exports = __webpack_public_path__ + "static/media/16.84e0e097.png";